const Autocomplete = skin => ({
  MuiAutocomplete: {
    styleOverrides: {
      // Label position/color used to live here too (a second copy of the
      // same centering logic as MuiInputLabel in input.js, off by 2px from
      // it — 14px vs 12px). Removed: MuiInputLabel's own rule already
      // covers every label in the app, including inside Autocomplete, so
      // there's no need for a second definition that can drift out of sync.

      // minHeight (not a fixed height) is 48px to match the platform-wide
      // standard used by every TextField and plain Select (see MuiTextField
      // and MuiOutlinedInput in input.js) — a single-value Autocomplete like
      // "Select Segment"/"Select Template" should be exactly the same height
      // as "Audience Smart Omnichannel Settings" or any other field next to
      // it. Using minHeight instead of height still lets multi-select
      // Autocompletes (Tags, Enable Channels, etc.) grow taller than 48px
      // when their chips wrap onto multiple lines.
      inputRoot: ({ theme }) => ({
        minHeight: 48,
        // reset normal padding for input text so selected value aligns properly
        '& .MuiOutlinedInput-input': {
         // padding: '16.5px 14px' // <-- MUI default for outlined ~56px height
          fontSize: theme.typography.body1.fontSize,
          fontFamily: theme.typography.fontFamily,
          color: theme.palette.text.primary
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px'
        }
      }),

      paper: ({ theme }) => ({
        boxShadow: theme.shadows[6],
        ...(skin === 'bordered' && {
          boxShadow: 'none',
          border: `1px solid ${theme.palette.divider}`
        })
      })
    }
  }
});

export default Autocomplete;
